import { CanDeactivateFn } from '@angular/router';
import type { HearingPhaseContentComponent } from './hearing-phase-content.component';

/** Preparation source edits must settle or be explicitly discarded before their editor is destroyed. */
export const hearingPreparationNavigationGuard: CanDeactivateFn<HearingPhaseContentComponent> =
  component => component.confirmNavigation();
